import { Col } from "reactstrap";
import { LatestBlogTitle } from "../../../../Constants/Constants";
import { LatestBlogData } from "../../../../Data/Blog/Blog";
import { dynamicImage, Image } from "../../../../Utils";

const LatestBlog = () => {
  return (
    <Col xs="12" className="px-0">
      <div className="blog-right-sidebar px-0">
        <h3>{LatestBlogTitle}</h3>
        {LatestBlogData.map((item, index) => (
          <div className="d-flex gap-2" key={index}>
            <h2>0{index + 1}.</h2>
            <div className="flex-grow-1">
              <p className="font-primary">{item.text}</p>
              <h4>{item.title}</h4>
              <p>{item.content}</p>
            </div>
            <div className="flex-shrink-0">
              <Image className="img-fluid rounded-circle" src={dynamicImage(`blog/small/${item.image}.jpg`)} alt="blog" />
            </div>
          </div>
        ))}
      </div>
    </Col>
  );
};

export default LatestBlog;
